import { InfoRow } from './InfoRow';

const name = 'InfoRow';

export { name, InfoRow };
